import React from 'react'
import { colors } from '@resurs/midas'
import { getText } from '../../../internal/TextLabels'
import styles from './styles.module.scss'

const renderStyle = checked =>
  checked
    ? {
        color: 'white',
        backgroundColor: colors.primaryMain,
      }
    : { color: colors.primaryMain, backgroundColor: 'transparent' }

const PushOutSwitch = ({ checked, onChange }) => (
  <div className={styles.container}>
    <div className={styles.content}>
      <input
        id="self-service"
        type="button"
        style={renderStyle(checked)}
        value={getText('payApply.pushToCustomer.sendForm')}
        onClick={onChange}
      />
      <input
        id="merchant"
        type="button"
        style={renderStyle(!checked)}
        value={getText('payApply.pushToCustomer.editForm')}
        onClick={onChange}
      />
    </div>
  </div>
)

export default PushOutSwitch
